import React from 'react';
import styled from 'styled-components';
import AboutSection from '../components/AboutSection';

const PageContainer = styled.div`
  padding-top: var(--header-h); /* Header yüksekliği kadar boşluk */
  min-height: 100vh;
`;

const AboutPage: React.FC = () => {
  return (
    <PageContainer>
      <AboutSection />
    </PageContainer>
  );
};

export default AboutPage;
